import React from 'react';
import { Container, Typography, Box, Grid } from '@mui/material';
import { useNavigate, useOutletContext } from 'react-router-dom';
import PropertyFooterLayout from '../../../components/properties/PropertyFooterLayout';
import WifiIcon from '@mui/icons-material/Wifi';
import WaterIcon from '@mui/icons-material/Water';
import FlashOnIcon from '@mui/icons-material/FlashOn';
import CleaningServicesIcon from '@mui/icons-material/CleaningServices';
import TvIcon from '@mui/icons-material/Tv';
import LocalLaundryServiceIcon from '@mui/icons-material/LocalLaundryService';
import FridgeIcon from '@mui/icons-material/Kitchen';
import MicrowaveIcon from '@mui/icons-material/Microwave';
import OutdoorGrillIcon from '@mui/icons-material/OutdoorGrill';
import BathroomIcon from '@mui/icons-material/Bathroom';


const progress = 0;
const step = 2;

type PublishOutletContext = {
  handleNavigateToPropertyAmenities: () => void;
  propertyServices: string;
  setPropertyServices: (propertyServices: string) => void;
};

const services = [
  { id: 'wifi', icon: <WifiIcon />, label: 'Wi-Fi' },
  { id: 'tv', icon: <TvIcon />, label: 'Televisión' },
  { id: 'nevera', icon: <FridgeIcon />, label: 'Nevera' },
  { id: 'microondas', icon: < MicrowaveIcon />, label: 'Microondas' },
  { id: 'estufa', icon: <OutdoorGrillIcon />, label: 'Estufa' },
  { id: 'Calentador de agua', icon: <BathroomIcon />, label: 'Calentador de agua' },
  { id: 'lavadora', icon: <LocalLaundryServiceIcon />, label: 'Lavadora' },
  { id: 'secadora', icon: <LocalLaundryServiceIcon />, label: 'Secadora' },
  { id: 'agua', icon: <WaterIcon />, label: 'Agua' },
  { id: 'electricidad', icon: <FlashOnIcon />, label: 'Electricidad' },
  { id: 'limpieza', icon: <CleaningServicesIcon />, label: 'Limpieza' },
];

const PropertyServicesPage: React.FC = () => {
  const navigate = useNavigate();
  const { handleNavigateToPropertyAmenities, propertyServices, setPropertyServices} = useOutletContext<PublishOutletContext>();

  const handleSelectionChange = (id: string) => {
    const current = (propertyServices)
        .split(',').map(item => item.trim()).filter(item => item.length > 0);

    const newSet = new Set(current);

    if (newSet.has(id)) {
        newSet.delete(id);
    } else {
        newSet.add(id);
    }
    const updatedList = Array.from(newSet).join(', ');
        setPropertyServices(updatedList);
};

  const handleBack = () => {
    navigate(-1); 
  };

  const handleContinue = () => {
    handleNavigateToPropertyAmenities();
  };

  return (
    <Container maxWidth="md" sx={{ display: 'flex', pb:10,flexDirection: 'column', minHeight: '95vh', alignItems: 'center' }}>
      <Box mt={4} mb={4} p={4} sx={{ borderRadius: 2, boxShadow: 4, width: '100%' }}>
        <Typography variant="h4" gutterBottom textAlign="center" sx={{mb:4}}>
          Selecciona los Servicios de la Propiedad
        </Typography>

        {/* Servicios Section */}
        <Box mb={4}>
          <Grid container spacing={2}>
            {services.map(service => (
              <Grid item xs={12} sm={6} md={4} key={service.id}>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    p: 2,
                    borderRadius: 2,
                    boxShadow: 2,
                    cursor: 'pointer',
                    backgroundColor: propertyServices.split(', ').includes(service.id) ? '#b2dfdb' : 'background.paper',
                    color: propertyServices.split(', ').includes(service.id) ? 'background.paper' : 'text.primary',
                    transition: 'background-color 0.3s ease, transform 0.2s ease',
                    '&:hover': {
                      transform: 'scale(1.05)',
                      boxShadow: 3,
                    },
                  }}
                  onClick={() => handleSelectionChange(service.id)}
                >
                  <Box sx={{ mr: 2 }}>
                    <Typography variant="body1" sx={{ fontSize: '2.5rem' }}>
                      {service.icon}
                    </Typography>
                  </Box>
                  <Typography variant="body1" sx={{ fontSize: '1.2rem', fontWeight: 'bold' }}>
                    {service.label}
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Box>

      <PropertyFooterLayout
        progress={progress}
        step={step}
        onBack={handleBack}
        onContinue={handleContinue}
        isContinueDisabled={false}
      />
    </Container>
  );
};

export default PropertyServicesPage;
